import React from 'react'
import useRecruitingInterview, {
  FALLBACK_RECRUITING_LINK,
} from './../../../../shared/hooks/useRecruitingInterview.hook'
import './CareersHeroSection.component.scss'

const CareersHeroSection = () => {
  const { loading, goToInterview } = useRecruitingInterview()

  return (
    <section className='careers-hero-section'>
      <div className='careers-hero-section__inner'>
        <h1 className='careers-hero-section__headline'>
          <span>More Than a Career — A </span>
          <strong className='careers-hero-section__growth'>GROWTH</strong>
          <span> Platform</span>
        </h1>

        <p className='careers-hero-section__subtitle'>
          At USA Benefits Group, we&rsquo;re committed to helping professionals build meaningful, rewarding careers in
          the benefits and insurance space. Our nationwide network of agents and team members are united by a shared
          mission: delivering personalized coverage guidance that improves lives while building long-term professional
          success.
        </p>

        <div className='careers-hero-section__button-row'>
          <a
            className='careers-hero-section__btn careers-hero-section__btn--red'
            href='https://vimeo.com/showcase/8843553'
            target='_blank'
            rel='noopener noreferrer'
          >
            Real Testimonials From USABG Agents
          </a>
          <a
            className='careers-hero-section__btn careers-hero-section__btn--navy'
            href={FALLBACK_RECRUITING_LINK}
            onClick={goToInterview}
            aria-busy={loading}
          >
            {loading ? 'Finding a recruiter…' : 'Schedule An Interview'}
          </a>
        </div>
      </div>
    </section>
  )
}

export default CareersHeroSection
